import {Part} from './part.model';
import {Assignment} from './assignment.model';

export class Case {
  caseId: string;
  specialityName: string;
  specialityCode: string;
  programName: string;
  programCode: string;
  testName: string;
  testCode: string;
  grade: string;
  candidateId: string;
  caseStatus: string;
  caseStatusCode: string;
  reviewerName: string;
  reviewerId: string;
  contentTypeCode: string;
  parts: Part[];
  receiptDate: number;
  errorMsg: string;
  assignment: Assignment;
  testDate: string;
  flaggedDate: string;
  candidateInitials: string;
  promptSetCode: string;
  promptSetName: string;
}
